module.exports = "<div class=\"npg-dialog-widget\">\n  <div class=\"npg-dialog-content\"></div>\n  <div class=\"npg-dialog-footer\"></div>\n</div>"